<table class="checks-table">
    <thead>
    <tr>
        <th width="400">Counter Name</th>
        <th width="80">Count</th>
        <th width="120">Total [ms]</th>
        <th width="80">Min [ms]</th>
        <th width="80">Max [ms]</th>
        <th width="80">Avg [ms]</th>
    </tr>
    </thead>
    <tbody>
        @for (tracker of trackers(); track tracker.name) {
            <tr [class.check-navigation-row]="tracker.count > 0">
                <td class="name">{{tracker.name}}</td>
                <td>{{tracker.count | number: '1.0-0'}}</td>
                <td>{{tracker.totalDuration | number: '1.0'}}</td>
                <td>{{tracker.minDuration | number: '1.2-2'}}</td>
                <td>{{tracker.maxDuration | number: '1.2-2'}}</td>
                <td>{{tracker.averageDuration | number: '1.2-2'}}</td>
            </tr>
        }
    </tbody>
</table>
